import { render, staticRenderFns } from "./QuizEdit.vue?vue&type=template&id=3c29c997&scoped=true&"
import script from "./QuizEdit.vue?vue&type=script&lang=js&"
export * from "./QuizEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c29c997",
  null
  
)

export default component.exports